import { createContext, useContext } from 'react';
import type { PublicTenant } from '@shared/contracts.ts';

export interface TenantCtx {
  slug: string;
  tenant: PublicTenant;
  /** Base path of this studio, e.g. /s/<slug>/ */
  base: string;
}

export const TenantContext = createContext<TenantCtx | null>(null);

export function useTenant(): TenantCtx {
  const ctx = useContext(TenantContext);
  if (!ctx) throw new Error('useTenant outside TenantRoot');
  return ctx;
}
